<template>
    <div class="app-body">
        <div class="a-flex-rsbc a-ptb-6">
            <span class="a-fs-16 a-fw-b">标的管理</span>
            <div class="a-flex-rcc">
                <el-button icon="el-icon-plus" type="primary" class="s-btn-add a-ml-24 myblue" @click="handlerEdit()">标的</el-button>
            </div>
        </div>
        <el-card class="el-main">
            <le-search-form @reset="handlerRest" @search="handlerSearch" :canPackUp="false" id="leSearch">
                <le-input label="标的名称" v-model="pageParam.params.name" />
                <le-company-investors-select label="资方" v-model="pageParam.params.companyId"></le-company-investors-select>
                <le-input-date
                    label="起始时间" 
                    ref="dateRange"
                    type='month'
                    v-model="pageParam.params.startDate"
                    valueFormat="yyyy-MM-dd" 
                ></le-input-date>
                <le-input-date
                    label="结束时间" 
                    ref="dateRange"
                    type='month'
                    v-model="pageParam.params.endDate"
                    valueFormat="yyyy-MM-dd" 
                ></le-input-date>
                <!-- <le-date-range 
                    label="起始时间" 
                    ref="dateRange" 
                    :pickerOptions="pickerOptions" 
                    :minDate.sync="pageParam.params.startStartDate" 
                    :maxDate.sync="pageParam.params.startEndDate" 
                    valueFormat="yyyy-MM-dd HH:mm:ss" 
                    :clearable='false' />
                <le-date-range 
                    label="结束时间" 
                    ref="dateRange" 
                    :pickerOptions="pickerOptions" 
                    :minDate.sync="pageParam.params.endStartDate" 
                    :maxDate.sync="pageParam.params.endEndDate" 
                    valueFormat="yyyy-MM-dd HH:mm:ss" 
                    :clearable='false' /> -->
            </le-search-form>
            <le-pagview ref="exportPage" @setData="setTableData" :pageParam="pageParam" :isFixed="true" :tableRef="$refs.exportList">
                <el-table 
                    ref="exportList"
                    :data="tableData" 
                    :highlight-current-row="true" 
                    v-sticky="{ top: 0, parent:'.el-card__body' }"
                    style="width: 100%">
                    <el-table-column prop="" label="标的名称" min-width="120">
                        <template slot-scope="{ row }">
                            <span>{{ row.name?row.name:'-' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="" label="资方" min-width="120">
                        <template slot-scope="{ row }">
                            <span>{{ row.companyName?row.companyName:'-' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="" label="投资金额" min-width="120">
                        <template slot-scope="{ row }">
                            <span>￥{{ util.numFormat(row.investAmount) }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="" label="兜底收益(月)" min-width="120">
                        <template slot-scope="{ row }">
                            <span>￥{{ util.numFormat(row.baseAmount) }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="" label="预期收益率" min-width="120">
                        <template slot-scope="{ row }">
                            <span>{{ row.expectRatio?row.expectRatio:'-' }}%</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="" label="起始时间" min-width="120">
                        <template slot-scope="{ row }">
                            <span>{{ row.startDate?$getDay.getTimeStampToStr(row.startDate, 'YYYY-MM'):'-' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="" label="结束时间" min-width="120">
                        <template slot-scope="{ row }">
                            <span>{{ row.endDate?$getDay.getTimeStampToStr(row.endDate, 'YYYY-MM'):'-' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="" label="期数" min-width="120">
                        <template slot-scope="{ row }">
                            <span>{{ row.totalTerm?row.totalTerm:'-' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="" label="历史收益" min-width="120">
                        <template slot-scope="{ row }">
                            <span>￥{{ util.numFormat(row.historyIncome) }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="name" label="操作" width="80" fixed="right">
                        <template slot-scope="scope">
                            <el-tooltip class="item" effect="dark" content="编辑" placement="top">
                                <img src="../../assets/icon/option-edit.png" class="a-wh-16" @click="handlerEdit(scope.row)" />
                            </el-tooltip>
                            <el-tooltip class="item a-ml-12" effect="dark" content="月度账单" placement="top">
                                <img src="../../assets/icon/option-detail.png" class="a-wh-16" @click="handlerToIncome(scope.row)" />
                            </el-tooltip>
                        </template>
                    </el-table-column>
                </el-table>
            </le-pagview>
        </el-card>
    </div>
</template>

<script>
import util from '@/utils/util'
export default {
    data() {
        return {
            util,
            tableData: [],
            pageParam: {
                url: this.$Config.apiUrl.underlyingPage,
                method: "post",
                params: {
                    companyId: '',
                    endEndDate: '',
                    endStartDate: '',
                    startEndDate: '',
                    startStartDate: '',
                    name: '',
                },
                freshCtrl: 1,
            },
            pickerOptions: {
                onPick: ({ maxDate, minDate }) => {
                    this.choiceDate = minDate.getTime()
                    if (maxDate) this.choiceDate = ''
                },
                disabledDate: (time) => {
                    if (this.choiceDate) {
                        const one = 92 * 24 * 3600 * 1000
                        const minTime = this.choiceDate - one
                        const maxTime = this.choiceDate + one
                        return time.getTime() < minTime || time.getTime() > maxTime
                    }else{
                        return ''
                    }
                },
            },
        };
    },
    mounted () {

    },  
    activated () {
		this.pageParam.freshCtrl++;
	},
    methods: {
        setTableData(data) {
            this.tableData = data;
        },
        handlerRest() {
            this.pageParam.params = {
                companyId: '',
                endEndDate: '',
                endStartDate: '',
                startEndDate: '',
                startStartDate: '',
                name: '',
            };
            this.handlerSearch()
        },
        handlerSearch() {
            this.$refs['exportPage'].pageNum = 1
            this.pageParam.freshCtrl++;
        },
        handlerEdit (datas) {
            this.$router.push({
			    path: "/underlyingAsset/underlying-edit",
				query: {
				    id: datas ? datas.id : '',
				},
			});
        },
        handlerToIncome (datas) {
            this.$router.push({
			    path: "/underlyingAsset/underlying-income",
				query: {
				    id: datas ? datas.id : '',
				},
			});
        },
    },
}
</script>

<style lang="scss" scoped>

</style>
